import { useState, useEffect } from "react";
import PageTitle from "../../../components/PageTitle";
// import Button from "../../../components/Button";
// import Modal from "../../../components/Modal";
// import useStyles from "../styles";
// import SelectGroup from "../../../components/FormComponent/SelectGroup";
// import { Grid } from "@mui/material";
// import { ClassType, Weekdays, Subject, ClassLevel } from "../../../utils/DropDown";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import PageLoader from "../../../components/PageLoader";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import ButtonCount from "../../../components/ButtonCount";
import useWindowSize from "../../../hooks/useWindow";
// import InputGroup from "../../components/FormComponent/InputGroup";

const STUDENT_SUBJECTS = "/api/v1/student/subjects";

const Student = () => {
  // const [searchResult, setSearchResult] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [studentSubject, setStudentSubject] = useState([]);

  /**
 * Fetches all student subjects from the API and updates local state.
 *
 * - Sets loading state while fetching.
 * - On success, updates both `studentSubject` and `searchResult` with the retrieved data.
 * - On failure, displays an error toast with the message from the response.
 *
 * @function
 */
  const getAllStudentSubject = () => {
    setIsPageLoading(true);
    httprequest.get(STUDENT_SUBJECTS).then((res) => {
      setIsPageLoading(false);
      setStudentSubject(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsPageLoading(false);
      toast.error(err?.response?.message);
    });
  };

  // On Page Load, set search result data to be the initial data
  useEffect(() => {
    setSearchResult(studentSubject);
    getAllStudentSubject();
  }, []);
  const width = useWindowSize();
  const mobile = width < 600;

  /**
 * Filters the student subject list based on the search input value.
 *
 * - Accepts input from an event object (typically from an input field).
 * - Splits the input into words and checks if every word matches any part
 *   of the subject name, teacher's email, or teacher's name.
 * - The filtered result is stored in `searchResult`.
 *
 * @function
 * @param {React.ChangeEvent<HTMLInputElement>} e - The input change event containing the search value.
 */
  const columns = [
    {
      name: "Subject Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Subject Name</p>}
          {row?.name || "--/--"}
        </>
      )
    },
    {
      name: "Teacher Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Teacher Name</p>}
          {`${row?.teachers?.[0]?.first_name || "--/--"} ${
            row?.teachers?.[0]?.last_name || "--/--"
          }`}
        </>
      )
    },
    {
      name: "Teacher Email",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Teacher Email</p>}
          {row?.teachers?.[0]?.email || "--/--"}
        </>
      )
    },
    {
      name: "Teacher Contact",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Teacher Contact</p>}
          {row?.teachers?.[0]?.contact || "--/--"}
        </>
      )
    },
    {
      name: "Class Material",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/class-activities/syllabus/${row?.subject_id || row?.id}`} className="table-action-icon">
            <Icon icon="carbon:text-link" />
          </Link>
        </div>
      )
    }
  ];

  /**
 * Filters the student subject list based on the search input value.
 *
 * - Accepts input from an event object (typically from an input field).
 * - Splits the input into words and checks if every word matches any part
 *   of the subject name, teacher's email, or teacher's name.
 * - The filtered result is stored in `searchResult`.
 *
 * @function
 * @param {React.ChangeEvent<HTMLInputElement>} e - The input change event containing the search value.
 */
  const handleSubject = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = studentSubject?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
          data?.teachers?.[0]?.email
            ?.toLowerCase()
            .includes(word.toLowerCase()) ||
                      data?.teachers?.[0]?.name
                        ?.toLowerCase()
                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <>
      <PageTitle
        title="Subject"
        subtitle="View all your Subject as a student"
      />
      {isPageLoading ? (<PageLoader />) :
        <>
          <>
            <div className="page-content">
              <div className="margin-bottom margin_tab">
                <ButtonCount count={studentSubject?.length} title="Number of Subjects" />
              </div>
              <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
                studentSubject?.length > 0 && (
                  <TableSearch placeholder="Search here..." searchTableFunc={handleSubject} />
                )}
              />
            </div>
          </>
        </>
      }
      {/* <ToastContainer /> */}
    </>
  );
};

export default Student;
